"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _PortalContext = _interopRequireDefault(require("../PortalContext"));
var _PortalWrapper = require("../PortalWrapper");
var _PortalContainerModule = _interopRequireDefault(require("./PortalContainer.module.css"));
/**
 * @deprecated используйте `PortalWrapper`
 */
var PortalContainer = function PortalContainer(props) {
  var children = props.children;
  var portalExitRef = _react.default.useRef(null);
  var contextValue = _react.default.useMemo(function () {
    return {
      getPortalContainer: function getPortalContainer() {
        return portalExitRef.current;
      }
    };
  }, []);
  return /*#__PURE__*/_react.default.createElement(_PortalContext.default.Provider, {
    value: contextValue
  }, /*#__PURE__*/_react.default.createElement(_PortalWrapper.PortalWrapper, {
    className: _PortalContainerModule.default.container,
    exitRef: portalExitRef
  }, children));
};
var _default = PortalContainer;
exports.default = _default;